module.exports = __webpack_public_path__ + "img/1_Dicks_Screen_3_R.4406a1a7.jpg";